import React from 'react';

import './page.css';
import LoadingPage from '../../components/loading/LoadingPage';
import MainTitle from '../../components/page/main-title/MainTitle';

import Biset from './Biset';
import Cadencia from './Cadencia';
import Dropset from './Dropset';
import Falha from './Falha';
import Foco90 from './Foco90';
import Gluteos from './Gluteos';
import MMII from './MMII';
import Mudancatreino from './Mudancatreino';
import Pernas from './Pernas';
import Restpause from './Restpause';
import Treinos from './Treinos';
import TreinosPlanilhas from './TreinosPlanilhas';
import TreinosDores from './TreinosDores';
import Isometria from './Isometria';
import IsolarMusculos from './IsolarMusculos';

import VIDEO from '../../img/video.svg';
import VIDEO_ACTIVE from '../../img/video-active.svg';

const FALHA = 1;
const CADENCIA = 2;
const BISET = 3;
const RESTPAUSE = 4;
const DROPSET = 5;
const Mmii = 6;
const MUDANCA_TREINO = 7;
const FOCO90 = 8;
const GLUTEOS = 9;
const PERNAS = 10;
const TREINOS_VARIOS = 11;
const TREINOS_PLANILHAS = 12;
const TREINOS_DORES = 13;
const ISOMETRIA = 14;
const TREINOS_ISOLAR = 15;

class Page extends React.Component{
  constructor (props){
    super(props);

    const data = this.getDataUser();
    const sexo = data ? data.sexo : 'F';

    this.state = {
      isLoading: false,
      perfil: FALHA,
      sexo
    }

    this.changeData = this.changeData.bind(this);
  }

  getPage() {
    switch(this.state.perfil){
      case TREINOS_ISOLAR:
        return <IsolarMusculos />;
      break;
      case FALHA:
        return <Falha />;
      break;
      case CADENCIA:
        return <Cadencia />;
      break;
      case BISET:
        return <Biset />;
      break;
      case RESTPAUSE:
        return <Restpause />
      break;
      case DROPSET:
        return <Dropset />
      break;
      case Mmii:
        return <MMII />
      break;
      case MUDANCA_TREINO:
        return <Mudancatreino sexo={this.state.sexo} />
      break;
      case FOCO90:
        return <Foco90 />
      break;
      case GLUTEOS:
        return <Gluteos />
      break;
      case PERNAS:
        return <Pernas />
      break;
      case TREINOS_VARIOS:
        return <Treinos />
      break;
      case TREINOS_PLANILHAS:
        return <TreinosPlanilhas />
      break;
      case TREINOS_DORES:
        return <TreinosDores />
      break;
      case ISOMETRIA:
        return <Isometria />
      break;
    }
  }

  changeData(e,tipo) {
    this.setState({
      perfil: tipo
    });

    var width = window.innerWidth
                || document.documentElement.clientWidth
                || document.body.clientWidth;

    if(width < 768){
      document.getElementById('wrapper-tecnicas').scrollIntoView();

    }else{
      var target = document.getElementById("wrapper-tecnicas");
      var top = target.offsetTop;
      document.documentElement.scrollTop = document.body.scrollTop = top;
    }


    e.preventDefault();
  }

  getDataUser(){
    const data = window.localStorage.getItem('dadosUser');

    if(data){
      const user = JSON.parse(data);

      return user;
    }
  }

  getButtonsFeminino(){
    return (
      <div>
        <a
          onClick={(e) => this.changeData(e, PERNAS)}
          className={`${(this.state.perfil === PERNAS ? 'ativo' : '')} button-mensagem`}
          href="#"
        >Por que treinar pernas 2 vezes na semana?</a>
        <a
          onClick={(e) => this.changeData(e, TREINOS_VARIOS)}
          className={`${(this.state.perfil === TREINOS_VARIOS ? 'ativo' : '')} button-mensagem`}
          href="#"
        >Por que tenho mais vezes treino de tronco na planilha de 5 e 6x na semana?</a>
        <a
          onClick={(e) => this.changeData(e, TREINOS_PLANILHAS)}
          className={`${(this.state.perfil === TREINOS_PLANILHAS ? 'ativo' : '')} button-mensagem`}
          href="#"
        >Por que as planilhas são “iguais” para todas e não são específicas? Quem está no nível Avançado vai treinar o mesmo treino de quem está no nível inicial?</a>
      </div>
    );
  }

  getButtonsMasculino(){
    return (
      <div>

        <a
          onClick={(e) => this.changeData(e, TREINOS_ISOLAR)}
          className={`${(this.state.perfil === TREINOS_ISOLAR ? 'ativo' : '')} button-mensagem`}
          href="#"
        >Por que não isolar os músculos no treino?</a>
      </div>
    );
  }

  render() {
    let wrapper = this.state.isLoading ? <LoadingPage /> : this.getPage();

    const foto = window.dadosUser ? window.dadosUser.foto : '';

    const buttonsFeminino = (this.state.sexo === 'F' || this.state.sexo === 'f') ? this.getButtonsFeminino() : '';
    const buttonsMasculino = (this.state.sexo === 'M' || this.state.sexo === 'm') ? this.getButtonsMasculino() : '';

    return (
      <div className="page-dashboard page-content" >
        <div className="container">
          <div className="container-box">
            <div className="container-box--inner">
              <MainTitle title="Técnicas"></MainTitle>
                <div>
                  <div className='wrapper-buttons-mensagens wrapper-buttons-mensagens__tecnicas'>
                    <a
                      onClick={(e) => this.changeData(e, FALHA)}
                      className={`${(this.state.perfil === FALHA ? 'ativo' : '')} button-mensagem`}
                      href="#"
                    >Falha Concêntrica / Repetições / Carga
                    <span className='video-icon'><img src={VIDEO} className='v-ic-in v-ic' /><img src={VIDEO_ACTIVE} className='v-ic-ac v-ic' /></span>
                  </a>
                    <a
                      onClick={(e) => this.changeData(e, CADENCIA)}
                      className={`${(this.state.perfil === CADENCIA ? 'ativo' : '')} button-mensagem`}
                      href="#"
                    >Entenda a cadência
                    <span className='video-icon'><img src={VIDEO} className='v-ic-in v-ic' /><img src={VIDEO_ACTIVE} className='v-ic-ac v-ic' /></span>
                  </a>
                    <a
                      onClick={(e) => this.changeData(e, BISET)}
                      className={`${(this.state.perfil === BISET ? 'ativo' : '')} button-mensagem`}
                      href="#"
                    >Entenda o BI SET
                    <span className='video-icon'><img src={VIDEO} className='v-ic-in v-ic' /><img src={VIDEO_ACTIVE} className='v-ic-ac v-ic' /></span>
                  </a>
                    <a
                      onClick={(e) => this.changeData(e, RESTPAUSE)}
                      className={`${(this.state.perfil === RESTPAUSE ? 'ativo' : '')} button-mensagem`}
                      href="#"
                    >Entenda o REST PAUSE
<span className='video-icon'><img src={VIDEO} className='v-ic-in v-ic' /><img src={VIDEO_ACTIVE} className='v-ic-ac v-ic' /></span>
                  </a>
                    <a
                      onClick={(e) => this.changeData(e, DROPSET)}
                      className={`${(this.state.perfil === DROPSET ? 'ativo' : '')} button-mensagem`}
                      href="#"
                    >Entenda sobre o DROP SET
<span className='video-icon'><img src={VIDEO} className='v-ic-in v-ic' /><img src={VIDEO_ACTIVE} className='v-ic-ac v-ic' /></span>
                  </a>
                  <a
                    onClick={(e) => this.changeData(e, ISOMETRIA)}
                    className={`${(this.state.perfil === ISOMETRIA ? 'ativo' : '')} button-mensagem`}
                    href="#"
                  >Entenda a Isometria
<span className='video-icon'><img src={VIDEO} className='v-ic-in v-ic' /><img src={VIDEO_ACTIVE} className='v-ic-ac v-ic' /></span>
                </a>
                    <a
                      onClick={(e) => this.changeData(e, Mmii)}
                      className={`${(this.state.perfil === Mmii ? 'ativo' : '')} button-mensagem`}
                      href="#"
                    >Exemplo Treino de MMII
<span className='video-icon'><img src={VIDEO} className='v-ic-in v-ic' /><img src={VIDEO_ACTIVE} className='v-ic-ac v-ic' /></span>
                  </a>
                    <a
                      onClick={(e) => this.changeData(e, MUDANCA_TREINO)}
                      className={`${(this.state.perfil === MUDANCA_TREINO ? 'ativo' : '')} button-mensagem`}
                      href="#"
                    >Como funciona a mudança dos treinos?</a>
                    <a
                      onClick={(e) => this.changeData(e, GLUTEOS)}
                      className={`${(this.state.perfil === GLUTEOS ? 'ativo' : '')} button-mensagem`}
                      href="#"
                    >Por que não isolar glúteos e treinar pernas no mesmo dia?</a>

                    {buttonsMasculino}
                    {buttonsFeminino}

                    <a
                      onClick={(e) => this.changeData(e, TREINOS_DORES)}
                      className={`${(this.state.perfil === TREINOS_DORES ? 'ativo' : '')} button-mensagem`}
                      href="#"
                    >Informações para quem tem dores nos joelhos/coluna</a>

                  </div>
                  <div className="listagem listagem-mensagens" id="wrapper-tecnicas">
                    {wrapper}
                  </div>
                  <div className='clear'></div>
                </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Page;



// WEBPACK FOOTER //
// ./src/classes/tecnicas/Page.js